import LegalLayout, {
  LegalH2,
  LegalP,
  LegalList,
} from "@/components/LegalLayout";

const CONTACT_EMAIL = "hola@matronaia.com";

export default function Terms() {
  return (
    <div data-testid="terms-page">
      <LegalLayout
        eyebrow="Documento legal"
        title="Términos y Condiciones de Uso"
        lastUpdated="1 de julio de 2026"
      >
        <LegalP>
          Bienvenida a Matrona IA. Estos Términos y Condiciones regulan el
          acceso y uso de la aplicación y la web de Matrona IA. Al utilizar
          Matrona IA, la usuaria acepta estos términos.
        </LegalP>

        <LegalH2>1. Naturaleza del servicio</LegalH2>
        <LegalP>
          Matrona IA es una aplicación de acompañamiento, orientación e
          información educativa sobre embarazo, parto, posparto, lactancia,
          crianza, duelo perinatal y salud maternoinfantil.
        </LegalP>
        <LegalP>
          La información ofrecida por Matrona IA tiene finalidad exclusivamente
          informativa, educativa y de apoyo.
        </LegalP>
        <LegalP>
          Matrona IA no es un servicio sanitario, médico, psicológico ni de
          urgencias. No realiza diagnósticos, no prescribe tratamientos, no
          sustituye la atención profesional y no debe utilizarse para tomar
          decisiones médicas importantes sin consultar con una matrona,
          ginecóloga, obstetra, pediatra, médica, enfermera, psicóloga u otro
          profesional sanitario cualificado.
        </LegalP>

        <LegalH2>2. Uso adecuado de la aplicación</LegalH2>
        <LegalP>
          La usuaria se compromete a utilizar Matrona IA de forma responsable,
          lícita y respetuosa.
        </LegalP>
        <LegalP>La usuaria no debe utilizar Matrona IA para:</LegalP>
        <LegalList
          items={[
            "Atender urgencias médicas.",
            "Sustituir una valoración profesional.",
            "Solicitar diagnósticos médicos definitivos.",
            "Obtener prescripciones, dosis o tratamientos individualizados.",
            "Subir imágenes de terceros sin autorización.",
            "Introducir información falsa, abusiva, ilegal o que vulnere derechos de otras personas.",
            "Intentar dañar, alterar, sobrecargar o acceder indebidamente a la plataforma.",
          ]}
        />

        <LegalH2>3. Información generada por inteligencia artificial</LegalH2>
        <LegalP>
          Matrona IA utiliza sistemas de inteligencia artificial para generar
          respuestas orientativas a partir de la información proporcionada por la
          usuaria.
        </LegalP>
        <LegalP>
          Aunque se busca ofrecer información útil, respetuosa y basada en
          evidencia, las respuestas pueden contener errores, limitaciones o no
          adaptarse completamente a una situación concreta.
        </LegalP>
        <LegalP>
          La usuaria debe contrastar cualquier decisión relevante sobre su salud
          o la de su bebé con profesionales sanitarios cualificados.
        </LegalP>

        <LegalH2>4. Situaciones de urgencia</LegalH2>
        <LegalP>
          Matrona IA no está diseñada para responder a emergencias médicas.
        </LegalP>
        <LegalP>
          En caso de síntomas graves, preocupación importante o emergencia, la
          usuaria debe contactar con los servicios sanitarios correspondientes,
          acudir a urgencias o llamar al 112.
        </LegalP>

        <LegalH2>5. Cuenta de usuaria</LegalH2>
        <LegalP>
          Para utilizar determinadas funciones de Matrona IA, puede ser necesario
          crear una cuenta.
        </LegalP>
        <LegalP>
          La usuaria es responsable de mantener la confidencialidad de sus
          credenciales de acceso y de la actividad realizada desde su cuenta.
        </LegalP>
        <LegalP>
          Si detecta un uso no autorizado de su cuenta, deberá comunicarlo a
          Matrona IA escribiendo a{" "}
          <a
            href={`mailto:${CONTACT_EMAIL}`}
            className="text-[#b7677a] underline underline-offset-4 decoration-[#f1c8d0]"
          >
            {CONTACT_EMAIL}
          </a>
          .
        </LegalP>

        <LegalH2>6. Suscripciones y pagos</LegalH2>
        <LegalP>
          Matrona IA puede ofrecer funciones gratuitas y funciones de pago
          mediante suscripción.
        </LegalP>
        <LegalP>
          Las suscripciones pueden gestionarse a través de Apple App Store,
          Google Play u otros proveedores de pago autorizados.
        </LegalP>
        <LegalP>
          Las condiciones concretas de precio, duración, renovación, cancelación,
          prueba gratuita y reembolso serán las indicadas en la tienda
          correspondiente en el momento de la contratación.
        </LegalP>
        <LegalP>
          Las suscripciones con renovación automática se renuevan salvo que la
          usuaria las cancele desde su cuenta de Apple App Store o Google Play
          antes de la fecha de renovación.
        </LegalP>
        <LegalP>
          Matrona IA no gestiona directamente los cobros, cancelaciones o
          reembolsos cuando estos se realizan a través de Apple App Store o
          Google Play. En esos casos, la usuaria deberá gestionar la suscripción
          desde la tienda correspondiente.
        </LegalP>

        <LegalH2>7. Cancelación de suscripción</LegalH2>
        <LegalP>
          La eliminación de la cuenta de Matrona IA no cancela automáticamente
          una suscripción activa gestionada por Apple App Store o Google Play.
        </LegalP>
        <LegalP>
          Para evitar futuros cobros, la usuaria debe cancelar la suscripción
          desde su cuenta de Apple o Google.
        </LegalP>

        <LegalH2>8. Eliminación de cuenta y datos</LegalH2>
        <LegalP>
          La usuaria puede solicitar la eliminación de su cuenta y datos
          personales en cualquier momento.
        </LegalP>
        <LegalP>
          Puede hacerlo desde la opción disponible en la aplicación o escribiendo
          a{" "}
          <a
            href={`mailto:${CONTACT_EMAIL}`}
            className="text-[#b7677a] underline underline-offset-4 decoration-[#f1c8d0]"
          >
            {CONTACT_EMAIL}
          </a>{" "}
          desde el email asociado a su cuenta.
        </LegalP>
        <LegalP>
          La eliminación de datos se realizará conforme a lo indicado en la
          Política de Privacidad y en la página “Eliminar cuenta y datos”.
        </LegalP>

        <LegalH2>9. Propiedad intelectual</LegalH2>
        <LegalP>
          Los textos, diseño, marca, logotipo, estructura, contenidos, nombre
          comercial y elementos visuales de Matrona IA pertenecen a sus titulares
          o se utilizan con autorización.
        </LegalP>
        <LegalP>
          La usuaria no puede copiar, reproducir, distribuir, modificar, vender o
          explotar comercialmente los contenidos de Matrona IA sin autorización
          previa y por escrito.
        </LegalP>

        <LegalH2>10. Privacidad y protección de datos</LegalH2>
        <LegalP>
          El tratamiento de datos personales se regula en la Política de
          Privacidad de Matrona IA.
        </LegalP>
        <LegalP>
          Matrona IA no vende datos personales, datos de salud, conversaciones,
          imágenes ni información de las usuarias a terceros.
        </LegalP>

        <LegalH2>11. Limitación de responsabilidad</LegalH2>
        <LegalP>
          Matrona IA se ofrece como herramienta de información, orientación y
          acompañamiento.
        </LegalP>
        <LegalP>
          Matrona IA no será responsable de decisiones tomadas exclusivamente en
          base a la información proporcionada por la aplicación, ni de daños
          derivados del uso inadecuado del servicio, retraso en la búsqueda de
          atención médica, interpretación incorrecta de la información o falta de
          consulta con profesionales sanitarios cuando sea necesario.
        </LegalP>
        <LegalP>
          Matrona IA no garantiza que el servicio esté disponible de forma
          ininterrumpida, libre de errores o sin incidencias técnicas.
        </LegalP>

        <LegalH2>12. Modificaciones del servicio</LegalH2>
        <LegalP>
          Matrona IA podrá actualizar, modificar, suspender o retirar funciones
          de la aplicación o de la web por motivos técnicos, legales, de
          seguridad o de mejora del servicio.
        </LegalP>

        <LegalH2>13. Cambios en estos términos</LegalH2>
        <LegalP>
          Matrona IA podrá actualizar estos Términos y Condiciones cuando sea
          necesario.
        </LegalP>
        <LegalP>
          Si los cambios son relevantes, se intentará informar a las usuarias a
          través de la aplicación, la web o el correo electrónico.
        </LegalP>
        <LegalP>
          El uso continuado de Matrona IA tras la actualización implica la
          aceptación de los nuevos términos.
        </LegalP>

        <LegalH2>14. Legislación aplicable</LegalH2>
        <LegalP>
          Estos términos se rigen por la legislación española y europea
          aplicable.
        </LegalP>

        <LegalH2>15. Contacto</LegalH2>
        <LegalP>
          Para cualquier duda sobre estos Términos y Condiciones, puedes
          escribir a{" "}
          <a
            href={`mailto:${CONTACT_EMAIL}`}
            className="text-[#b7677a] underline underline-offset-4 decoration-[#f1c8d0]"
          >
            {CONTACT_EMAIL}
          </a>
          .
        </LegalP>
      </LegalLayout>
    </div>
  );
}